import Box from '@mui/material/Box';
import { Form, RadioButtonGroupInput } from 'react-admin';
import TextInputWithLabels from '@/components/common/forms/common/text-input-with-labels/text-input-with-labels';
import ImageInputWithLabelOnTop from '@/components/common/forms/common/image-input-with-label-on-top/image-input-with-label-on-top';

const formId = '_form_maintenance_audit_1';

interface Props {
    readOnly?: boolean;
    defaultValues?: (formId: string) => {};
}

export const transformRadioButtonOptionsToShow = (
    primaryKey: string,
    data: {
        [key: string]: string | { [key: string]: boolean };
    },
) => {
    if (typeof data[primaryKey] === 'object') {
        const radioValues = data[primaryKey] as { [key: string]: boolean };
        const selectedKey = Object.keys(radioValues).find((key) => radioValues[key]);
        if (selectedKey) {
            return {
                ...data,
                [primaryKey]: selectedKey,
            };
        }
    }
    return data;
};

const AuditForm = ({ readOnly = false, defaultValues = (_formId: string): any => {} }: Props) => {
    return (
        <Form defaultValues={transformRadioButtonOptionsToShow('surface_radio_button_group', defaultValues(formId))}>
            <Box
                sx={{
                    display: 'grid',
                    gap: 2,
                }}
            >
                <TextInputWithLabels
                    topLabel={'Description du besoin:'}
                    source='AuditTxt'
                    multiline
                    readOnly={readOnly}
                />

                <RadioButtonGroupInput
                    label={false}
                    source='surface_radio_button_group'
                    choices={[
                        {
                            id: 'SurLaGlobalité',
                            name: "Sur la globalité de l'entrepôt / entreprise",
                        },
                        {
                            id: 'SurUneSurface',
                            name: 'Sur une surface partielle',
                        },
                    ]}
                    helperText={false}
                    disabled={readOnly}
                />

                <TextInputWithLabels topLabel={'Surface'} rightLabel={'m²'} source='SurfaceM2' readOnly={readOnly} />

                <TextInputWithLabels
                    topLabel={'Précision sur la localisation'}
                    source='Localisation'
                    readOnly={readOnly}
                />

                <ImageInputWithLabelOnTop label='Joindre des photos (.png, .jpg)' source='media' readOnly={readOnly} />
            </Box>
        </Form>
    );
};

export default AuditForm;
